import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function WifiIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<g transform="translate(8 7.4) scale(0.72) translate(-8 -8)"><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.6} d="M4.137 7.039a4 4 0 0 1 .723-3.516M11.14 7.04a4 4 0 0 0-.723-3.516M1.56 7.733a6.67 6.67 0 0 1 1.404-6.103M14.437 7.733a6.67 6.67 0 0 0-1.404-6.103M8 10V6m-4.333 6.333h2.666M3.467 14.667h9.066c.747 0 1.12 0 1.405-.146a1.33 1.33 0 0 0 .583-.582c.146-.286.146-.658.146-1.406v-.4c0-.747 0-1.12-.146-1.405a1.33 1.33 0 0 0-.583-.583c-.285-.145-.658-.145-1.405-.145H3.467c-.747 0-1.12 0-1.405.145a1.33 1.33 0 0 0-.583.583c-.146.285-.146.658-.146 1.405v.4c0 .748 0 1.12.146 1.406.128.249.334.455.583.582.285.146.658.146 1.405.146" /></g></svg>
  );
}

export default WifiIcon;
